export const convertToDataURI = (svg) => (svg ? `data:image/svg+xml;utf8,${encodeURIComponent(svg)}` : '');
//# sourceMappingURL=utils.js.map